var _style, _style2, _g, _span, _span2, _span3, _span4, _rect, _span5, _rect2, _span6, _rect3, _span7, _rect4, _span8, _rect5, _span9, _defs, _defs2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase1ProjectStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-roledescription": "flowchart-v2",
    role: "graphics-document document",
    viewBox: "0 0 230.84375 504",
    style: {
      maxWidth: "230.844px",
      background: "rgb(23, 23, 25)"
    },
    className: "flowchart",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    id: "export-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css\"); p {margin: 0;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "#export-svg{font-family:arial,sans-serif;font-size:14px;fill:#ccc;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#export-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#export-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#export-svg .error-icon{fill:hsl(20, 1.5873015873%, 12.3529411765%);}#export-svg .error-text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);stroke:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .edge-thickness-normal{stroke-width:1px;}#export-svg .edge-thickness-thick{stroke-width:3.5px;}#export-svg .edge-pattern-solid{stroke-dasharray:0;}#export-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#export-svg .edge-pattern-dashed{stroke-dasharray:3;}#export-svg .edge-pattern-dotted{stroke-dasharray:2;}#export-svg .marker{fill:#cccccc;stroke:#cccccc;}#export-svg .marker.cross{stroke:#cccccc;}#export-svg svg{font-family:arial,sans-serif;font-size:14px;}#export-svg p{margin:0;}#export-svg .label{font-family:arial,sans-serif;color:#e0dfdf;}#export-svg .cluster-label text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span p{background-color:transparent;}#export-svg .label text,#export-svg span{fill:#e0dfdf;color:#e0dfdf;}#export-svg .node rect,#export-svg .node circle,#export-svg .node ellipse,#export-svg .node polygon,#export-svg .node path{fill:#2a2020;stroke:#ccc;stroke-width:1px;}#export-svg .rough-node .label text,#export-svg .node .label text,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-anchor:middle;}#export-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#export-svg .rough-node .label,#export-svg .node .label,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-align:center;}#export-svg .node.clickable{cursor:pointer;}#export-svg .root .anchor path{fill:#cccccc!important;stroke-width:0;stroke:#cccccc;}#export-svg .arrowheadPath{fill:#cccccc;}#export-svg .edgePath .path{stroke:#cccccc;stroke-width:1px;}#export-svg .flowchart-link{stroke:#cccccc;fill:none;}#export-svg .edgeLabel{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .edgeLabel p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .edgeLabel rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .labelBkg{background-color:rgba(71.1523809525, 73.4476190477, 73.4476190477, 0.5);}#export-svg .cluster rect{fill:hsl(20, 1.5873015873%, 12.3529411765%);stroke:hsl(20, 0%, 2.3529411765%);stroke-width:1px;}#export-svg .cluster text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(20, 1.5873015873%, 12.3529411765%);border:1px solid rgba(255, 255, 255, 0.25);border-radius:2px;pointer-events:none;z-index:100;}#export-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#ccc;}#export-svg rect.text{fill:none;stroke-width:0;}#export-svg .icon-shape,#export-svg .image-shape{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .icon-shape p,#export-svg .image-shape p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);padding:2px;}#export-svg .icon-shape rect,#export-svg .image-shape rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .node .neo-node{stroke:#ccc;}#export-svg [data-look=\"neo\"].node rect,#export-svg [data-look=\"neo\"].cluster rect,#export-svg [data-look=\"neo\"].node polygon{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node path{stroke:url(#export-svg-gradient);}#export-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node .neo-line path{stroke:#ccc;filter:none;}#export-svg [data-look=\"neo\"].node circle{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#export-svg [data-look=\"neo\"].statediagram-cluster rect{fill:#2a2020;stroke:url(#export-svg-gradient);stroke-width:1px;}#export-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 7.75,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 4,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 11.5,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 1,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart-margin"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 10.75,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 0,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 12.25,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: -2,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTE1LjQyMTg3NSwieSI6NzR9LHsieCI6MTE1LjQyMTg3NSwieSI6OTl9LHsieCI6MTE1LjQyMTg3NSwieSI6MTI0fV0=",
    "data-id": "L_P1_1_P1_2_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P1_1_P1_2_0",
    d: "M115.421875,74L115.421875,99L115.421875,120"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTE1LjQyMTg3NSwieSI6MTY5fSx7IngiOjExNS40MjE4NzUsInkiOjE5NH0seyJ4IjoxMTUuNDIxODc1LCJ5IjoyMTl9XQ==",
    "data-id": "L_P1_2_P1_3_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P1_2_P1_3_0",
    d: "M115.421875,169L115.421875,194L115.421875,215"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTE1LjQyMTg3NSwieSI6Mjg1fSx7IngiOjExNS40MjE4NzUsInkiOjMxMH0seyJ4IjoxMTUuNDIxODc1LCJ5IjozMzV9XQ==",
    "data-id": "L_P1_3_P1_4_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P1_3_P1_4_0",
    d: "M115.421875,285L115.421875,310L115.421875,331"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTE1LjQyMTg3NSwieSI6NDAxfSx7IngiOjExNS40MjE4NzUsInkiOjQyNn0seyJ4IjoxMTUuNDIxODc1LCJ5Ijo0NTF9XQ==",
    "data-id": "L_P1_4_P1_End_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P1_4_P1_End_0",
    d: "M115.421875,401L115.421875,426L115.421875,447"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P1_1_P1_2_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span || (_span = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P1_2_P1_3_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P1_3_P1_4_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P1_4_P1_End_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.421875, 41)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P1_1",
    id: "flowchart-P1_1-0",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 178.828125,
    y: -33,
    x: -89.4140625,
    "data-id": "P1_1",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73.4140625, -21)",
    style: {},
    className: "label"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 146.828125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "1.1 Prepare Workspace", /*#__PURE__*/React.createElement("br", null), "(Install Libraries)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.421875, 146.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P1_2",
    id: "flowchart-P1_2-1",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 214.84375,
    y: -22.5,
    x: -107.421875,
    "data-id": "P1_2",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.421875, -10.5)",
    style: {},
    className: "label"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 182.84375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "1.2 Import Libraries &amp; Utilities"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.421875, 252)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P1_3",
    id: "flowchart-P1_3-2",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 188.4375,
    y: -33,
    x: -94.21875,
    "data-id": "P1_3",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78.21875, -21)",
    style: {},
    className: "label"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 156.4375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span7 || (_span7 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "1.3 Define Storage Paths", /*#__PURE__*/React.createElement("br", null), "(SQLite, ChromaDB)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.421875, 368)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P1_4",
    id: "flowchart-P1_4-3",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 137.0625,
    y: -33,
    x: -68.53125,
    "data-id": "P1_4",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.53125, -21)",
    style: {},
    className: "label"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 105.0625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span8 || (_span8 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "1.4 Set API Keys", /*#__PURE__*/React.createElement("br", null), "(Kaggle Secrets)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.421875, 473.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P1_End",
    id: "flowchart-P1_End-4",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 102.0625,
    y: -22.5,
    x: -51.03125,
    "data-id": "P1_End",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.03125, -10.5)",
    style: {},
    className: "label"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 70.0625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span9 || (_span9 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "To Phase 2")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "130%",
    height: "130%",
    id: "drop-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 4,
    dx: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "150%",
    height: "150%",
    id: "drop-shadow-small"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 2,
    dx: 2
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: "0%",
    x2: "100%",
    y1: "0%",
    x1: "0%",
    gradientUnits: "objectBoundingBox",
    id: "export-svg-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0042eb",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#eb0042",
    offset: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase1ProjectStructure);
export default __webpack_public_path__ + "static/media/phase1_project_structure.17ce7f629ef103fdb423a7da3b600f1e.svg";
export { ForwardRef as ReactComponent };